var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .14 32.859",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 318.385 621.445)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .14 33.23",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 83.538 620.95)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 47.716-.201c8.667-.037 16.016-5.596 18.735-13.329 1.04-2.959 3.778-4.981 6.914-4.993 11.105-.047 20.07-9.087 20.023-20.193l-.177-41.927s-17.643.285-23.635-5.576c-1.26-1.231-3.376-.35-3.368 1.412l.116 27.562c.04 9.57-7.685 17.361-17.255 17.401l-.208.001a28.036 28.036 0 0 1-8.584-1.312c-4.91-1.557-9.993-2.504-15.144-2.482l-3.352.014c-5.151.021-10.225 1.011-15.122 2.609a28.02 28.02 0 0 1-8.573 1.385l-.208.001c-9.57.04-17.36-7.685-17.401-17.255l-.101-24.569a3.916 3.916 0 0 0-3.697-3.893l-6.458-.358a3.883 3.883 0 0 0-2.697.89c-5.92 4.911-14.13 4.759-14.13 4.759l.143 33.981C-46.355-20.52-25.553.107 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(128.465 374.378)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.531-1.814-5.958-5.479-5.975-9.724l-.051-12.174c-.026-6.068 4.872-11.008 10.94-11.034l4.155-.017c.275-15.947 6.91-31.322 18.972-41.796 9.709-8.432 23.377-15.814 41.472-16.092 18.096.125 31.826 7.392 41.607 15.742 12.149 10.371 18.914 25.691 19.323 41.634l4.155-.018c6.068-.025 11.007 4.874 11.033 10.941l.052 12.175c.017 4.244-2.378 7.929-5.893 9.774",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(81.873 294.324)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.109-25.879a9.793 9.793 0 0 0-8.578-9.673",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(117.22 214.033)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a9.79 9.79 0 0 0-8.495 9.745l.109 25.879",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(194.026 178.121)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-28.772-37.077c-5.112-6.588-14.625-7.723-21.144-2.521l-22.495 17.954 42.86 26.556C-22.256 3.935-11.19 2.286 0 0c0 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(223.578 173.209)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 28.511-37.371c5.066-6.64 14.589-7.844 21.148-2.673l22.567 17.79L29.592 4.662C22.289 3.746 11.209 2.191 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(78.94 173.82)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.65 17.07",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(141.056 117.34)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.605-17.155",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(172.662 134.41)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-10.396 71.34-20 .085L-41.421 0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(171.417 45.916)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .263 62.285",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(281.515 45.916)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-.125-29.834",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(20.054 75.75)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.624.315-1.254.621-1.896.91-15.617 7.032-45.175 11.648-59.728 13.599l-42.859-26.556-42.634 26.916c-14.569-1.828-44.165-6.194-59.841-13.095a47.635 47.635 0 0 1-28.443-43.397l-.047-11.083",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(255.65 163.612)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h89.395c7.262 0 13.149 5.888 13.149 13.149v116.075c0 7.262-5.887 13.149-13.149 13.149h-209.743c-7.262 0-13.149-5.887-13.149-13.149V13.149C-133.497 5.888-127.61 0-120.348 0h89.395",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(389.147 108.201)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h482.847a6.679 6.679 0 0 1 6.679 6.68v25.057a6.679 6.679 0 0 1-6.679 6.679H0a6.68 6.68 0 0 1-6.679-6.679V6.68A6.68 6.68 0 0 1 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(14.383 7.5)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v16.59a9.271 9.271 0 0 1-9.271 9.271h-65.696a9.272 9.272 0 0 1-9.272-9.271V0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(415.79 45.916)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.661 45.765a7.6 7.6 0 0 1-7.561 6.83h-13.927a7.6 7.6 0 0 1-7.561-6.83L-38.372 0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(392.856 71.777)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-11.521 9.34-20.86 20.86-20.86 11.521 0 20.861 9.339 20.861 20.86 0 11.521-9.34 20.86-20.861 20.86C9.34 20.86 0 11.521 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(352.81 187.992)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-33.03a2.666 2.666 0 0 1 2.667-2.666l17.967.007",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(416.56 452.46)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-48.455-39.281-87.735-87.736-87.735-48.455 0-87.736 39.28-87.736 87.735 0 48.456 39.281 87.736 87.736 87.736C-39.281 87.736 0 48.456 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(504.296 416.764)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c7.648 25.253 31.105 43.637 58.855 43.637 33.959 0 61.488-27.529 61.488-61.488 0-33.958-27.529-61.486-61.488-61.486-27.59 0-50.937 18.173-58.722 43.202",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(357.705 434.614)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkTime);
export default __webpack_public_path__ + "static/media/workTime.8ad4d458a8a0eb5ee4c78eee2ce4e71f.svg";
export { ForwardRef as ReactComponent };